import type { ComponentProps } from 'react';
import type { ApolloError } from '@apollo/client';
import type { RaygunV2 } from 'raygun4js';
import type { Country } from '@seek/chalice-types';
import type { ApacCandidateHeader } from '@seek/apac-candidate-header-footer';
import type { Language, SiteName } from '@seek/melways-sites';
import type { Config } from './config';
import type { RecommendationsData } from './queries/types';
import type {
  RECOMMENDED_JOBS_ROUTE_NAME,
  SAVED_SEARCH_ROUTE_NAME,
} from './constants';

export type Route =
  | typeof RECOMMENDED_JOBS_ROUTE_NAME
  | typeof SAVED_SEARCH_ROUTE_NAME;

export interface ClientContext {
  site: SiteName;
  environment: string;
  route: Route;
  language: Language;
}
export const skuEnvironments = [
  'development',
  'staging',
  'production',
] as const;
export type SkuEnvironment = (typeof skuEnvironments)[number];

export const supportedCountries: Country[] = [
  'AU',
  'NZ',
  'HK',
  'ID',
  'TH',
  'PH',
  'MY',
  'SG',
];

export type SolTracker = {
  trackDisplayed: (token: string) => void;
};
export enum ContainerWidth {
  Large = 'large',
  Medium = 'medium',
}

export type HeaderFooterSharedProps = {
  loading: boolean;
  error?: ApolloError;
};

type Candidate = NonNullable<RecommendationsData['viewer']>;

export type HeaderProps = Partial<
  Pick<Candidate, 'emailAddress' | 'trackingId' | 'id'>
> &
  HeaderFooterSharedProps & {
    firstName?: Candidate['personalDetails']['firstName'];
    width?: ContainerWidth;
    activeAuthedUserTab: ComponentProps<
      typeof ApacCandidateHeader
    >['activeAuthedUserTab'];
  };

export type FooterProps = HeaderFooterSharedProps & { width?: ContainerWidth };

declare global {
  interface Window {
    rg4js: RaygunV2;
    APP_CONFIG: Config;
    hj: any;
  }
}
